var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 686,
    height: 686,
    viewBox: "0 0 686 686",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1501_59)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2222 686H609.778C651.874 686 686 651.874 686 609.778V76.2222C686 34.1258 651.874 0 609.778 0H76.2222C34.1258 0 0 34.1258 0 76.2222V609.778C0 651.874 34.1258 686 76.2222 686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.722 590.722H488.924V417.336C488.924 369.799 470.861 343.233 433.235 343.233C392.303 343.233 370.917 370.879 370.917 417.336V590.722H272.812V260.425H370.917V304.916C370.917 304.916 400.415 250.334 470.506 250.334C540.565 250.334 590.722 293.117 590.722 381.599V590.722ZM155.773 217.176C122.356 217.176 95.2778 189.885 95.2778 156.227C95.2778 122.568 122.356 95.2773 155.773 95.2773C189.19 95.2773 216.252 122.568 216.252 156.227C216.252 189.885 189.19 217.176 155.773 217.176ZM105.116 590.722H207.414V260.425H105.116V590.722Z",
    fill: "#A93346"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1501_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 686,
    height: 686,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon_linkedin.ebddb87287629d6a3be247cec33f68fb.svg";
export { ForwardRef as ReactComponent };